const color = (pct) => (pct === 100 ? "bg-[#16A34A]" : pct >= 50 ? "bg-[#FFD600]" : "bg-[#F59E0B]");
const text = (pct) => (pct === 100 ? "text-[#16A34A]" : pct >= 50 ? "text-[#FFD600]" : "text-[#F59E0B]");

export default function ProgressCell({ pct, tid }) {
  return (
    <div className="min-w-[96px] shrink-0" data-testid={tid} title={`${pct}% compliance setup complete`}>
      <div className={`font-mono-label text-[11px] mb-1 ${text(pct)}`} data-testid={`${tid}-pct`}>{pct}%{pct < 50 && " · needs help"}</div>
      <div className="h-1.5 bg-[#262626] w-24" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100}>
        <div className={`h-full ${color(pct)}`} style={{ width: `${pct}%` }} />
      </div>
    </div>
  );
}
